import type { ReactNode } from 'react';
import type { GroupBase } from 'react-select';

import { Select } from '../Select';
import type { SelectProps } from '../Select';

import FormLabel from './FormLabel';
import type { FormLabelVariant } from './FormLabel';

type Props<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
> = SelectProps<Option, IsMulti, Group> & {
  /**
   * Text (or JSX nodes) to be rendered as the label.
   */
  label: ReactNode;
  /**
   * If the label will appear inline (instead of the default block styling).
   */
  isInline?: boolean;
  /**
   * Which type of form label to use.
   */
  variant?: FormLabelVariant;
};

const LabeledSelect = <Option, IsMulti extends boolean = false, Group extends GroupBase<Option> = GroupBase<Option>>(
  { label, isInline, variant, ...props }: Props<Option, IsMulti, Group>,
) => (
  <FormLabel
    label={label}
    variant={variant}
    isInline={isInline}
    htmlFor={props.id}
  >
    <Select
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  </FormLabel>);

export default LabeledSelect;
